
<ng-container *ngIf="loading">
    <div class="container-with-loading">
        <div class="loading-overlay">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</ng-container>
  
<mat-card class="offer-card" appearance="outlined" [hidden]="loading">
    <!--mat-card-header>
        <mat-card-title>Costo Empleado</mat-card-title>
	</mat-card-header-->
	<mat-card-content>

		<form class="form-container" (ngSubmit)="onSubmitBenefir(costsPerEmployeeGroupForm)" #costsPerEmployeeGroupForm="ngForm" >

			<mat-card class="general-wf-card" appearance="outlined">
				<!--mat-card-header>
					<mat-card-title>{{title}}</mat-card-title>
				</mat-card-header-->
				<mat-card-content>
					<div id="container" class="formControl">
					
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>Descripci&oacute;n</mat-label>
								<input type="text" matInput name="costsPerEmployee.description" [(ngModel)]="costsPerEmployee.description">
								<mat-error>{{ violations['costsPerEmployee.description'] }}</mat-error>
							</mat-form-field>
						</div>
						<div class="control">
							<mat-form-field class="controlWidth">
								<mat-label>C&oacute;digo</mat-label>
								<input type="text" matInput name="costsPerEmployee.attribute" [(ngModel)]="costsPerEmployee.attribute" (keydown.space)="$event.preventDefault()">
								<mat-error>{{ violations['costsPerEmployee.attribute'] }}</mat-error>
							</mat-form-field>
						</div>
                        <div class="control">
                            <mat-form-field class="controlWidth">
                              <mat-label>Tipo Costo</mat-label>
                              <mat-select [(ngModel)]="costsPerEmployee.costsPerEmployeeType"  [compareWith]="compareCostsPerEmployeeTypes" name="costsPerEmployee.costsPerEmployeeType" >
                              @for (costsPerEmployeeType of costsPerEmployeeTypes ; track costsPerEmployeeType.id) {
                                <mat-option [value]="costsPerEmployeeType">{{ costsPerEmployeeType.description }}</mat-option>
                              }
                            </mat-select>
							<mat-error>{{ violations['costsPerEmployee.costsPerEmployeeType'] }}</mat-error>
							<mat-error *ngIf="violations['costsPerEmployee.costsPerEmployeeType']">
								{{ violations['costsPerEmployee.costsPerEmployeeType'] }}
							  </mat-error>
                            </mat-form-field>
                        </div>
						<div class="control">
							<mat-slide-toggle [(ngModel)]="costsPerEmployee.active"  name="costsPerEmployeeActive" > 
							  {{ costsPerEmployee.active? 'Costo Activo':'Costo Inactivo'}} 
							</mat-slide-toggle>
						</div>
					</div>
				</mat-card-content>
			</mat-card>
			<div class="formControl">
				<div class="control">
					<button mat-flat-button class="button buttonWidth">
					  {{(costsPerEmployee.id > 0)? 'Actualizar': 'Guardar'}}
					</button>
				</div>
			</div>
		</form>
	</mat-card-content>
</mat-card>